import { Box, Grid } from '@mui/material'

import React from 'react'

function ItSection({phone}) {
  return (
    <Box bgcolor={"#424242"} display={"flex"} justifyContent={"center"} width="100%"  >
    <Grid container   p="30px 0" position={"relative"} width="100%"  display={"flex"} className='cover'   sx={{backgroundImage:'url(/images/it.png)'}}>

        <Grid item lg={12} xl={12} md={12} display={"flex"} flexDirection={"column"} alignItems={phone ?"center":'flex-start'} gap={4} p="20px">
            <Box display={"flex"} flexDirection={phone ? "column": "row"} gap={2} alignItems={"center"}>
                
                <img src="/images/branchIt.png" alt="" width={phone?"100px":'200px'} />
                <Box display={"flex"} flexDirection={"column"}>
                    <Box display={"flex"} gap={2} alignItems={"center"}>
                        <img src="/images/star.png" alt="" width={"30px"} height={"30px"} />
                        <h3 style={{fontSize:phone&&'1.4rem',color:phone ? "#fff":"#000",textAlign:'justify',color:'#fff',lineHeight:2}}> ایجادشده بر پایه فناوری اطلاعات </h3>

                    </Box>
                    <Box display={"flex"} gap={2} alignItems={"center"}>
                        <img src="/images/star.png" alt="" width={"30px"} height={"30px"} />
                        <h3 style={{fontSize:phone&&'1.4rem',color:phone ? "#fff":"#000",textAlign:'justify',color:'#fff',lineHeight:2}}> رعایت اصول جهانی فرانچایزینگ</h3>

                    </Box>
                    <Box display={"flex"} gap={2} alignItems={"center"}>
                        <img src="/images/star.png" alt="" width={"30px"} height={"30px"} />
                        <h3 style={{fontSize:phone&&'1.4rem',color:phone ? "#fff":"#000",textAlign:'justify',color:'#fff',lineHeight:2}}> سهولت ، شفافیت ، سرعت </h3>

                    </Box>
                    <Box display={"flex"} gap={2} alignItems={"center"}>
                        <img src="/images/star.png" alt="" width={"30px"} height={"30px"} />
                        <h3 style={{fontSize:phone&&'1.4rem',color:phone ? "#fff":"#000",textAlign:'justify',color:'#fff',lineHeight:2}}> امنیت خاطر سرمایه گذار</h3>

                    </Box>
                </Box>

            </Box>
            <Box display={"flex"} flexDirection={phone ? "column": "row"}  gap={2} alignItems={"center"} ml={!phone&&'80px'}>
                <img src="/images/personIt.png" alt=""    width={"40px"}  />
                <h6  style={{color:phone ? "#fff":"#000",fontWeight:phone&&'normal',textAlign:phone&&'center',color:'#fff',lineHeight:2}}> نخستین نرم افزار تخصصی مدیریت آنلاین فرانچایزینگ در ایران </h6>

            </Box>
            <Box display={"flex"}flexDirection={phone ? "column": "row"}  gap={2} alignItems={"center"} ml={!phone&&'80px'}>
                <img src="/images/successIt.png" alt=""  width={"40px"} />
                <h6 style={{color:phone ? "#fff":"#000",fontWeight:phone&&'normal',textAlign:phone&&'center',color:'#fff',lineHeight:2}}> یکپارچه سازی و کنترل ساختار زنجیره تامین جان اسنک  </h6>

            </Box>
            <Box display={"flex"}flexDirection={phone ? "column": "row"}  gap={2} alignItems={"center"} ml={!phone&&'80px'}>
                <img src="/images/basketIt.png" alt=""  width={"40px"} />
                <h6 style={{color:phone ? "#fff":"#000",fontWeight:phone&&'normal',textAlign:phone&&'center',color:'#fff',lineHeight:2}}> ساختار منحصر به فرد. تجزیه و تحلیل و ارایه داده های اثر بخش جهت ارتقای فروش شعب و افزایش رضایت مندی مشتریان و سرمایه گذاران </h6>

            </Box>
            <Box display={"flex"}flexDirection={phone ? "column": "row"}  gap={2} alignItems={"center"} ml={!phone&&'80px'}>
                <img src="/images/strucIt.png" alt=""   width={"40px"}/>
                <h6 style={{color:phone ? "#fff":"#000",fontWeight:phone&&'normal',textAlign:phone&&'center',color:'#fff',lineHeight:2}}> پیاده سازی و کنترل یکپارچه ساختارهای مورد نیاز در زمینه فرانچایزینگ مواد غذایی همراه با ارائه گزارش ها و تحلیل های دقیق تحلیلی و نموداری از بخش های مختلف مجموعه</h6>

            </Box>

        </Grid>
             
              
      </Grid>

  </Box>
  )
}

export default ItSection